import { Timestamp } from '@firebase/firestore-types';

export * from './aiSearches';
export * from './revisions';
export * from './savedSearches';

export interface Session {
    createdAt: Timestamp;
    sessionId: string;
}

export interface User {
    company?: string;
    email: string;
    firstName: string;
    hubspotId?: string;
    jobTitle?: string;
    lastName: string;
    phoneNumber?: string;
    session: Session;
}
/** User data needed to create user account */
export type UserData = Pick<
    User,
    'email' | 'firstName' | 'jobTitle' | 'lastName' | 'phoneNumber' | 'company'
>;

export type FormSource = 'from_signup_page' | 'from_freemium_modal' | 'from_freemium_paywall';
